import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || (typeof window !== 'undefined' ? window.location.origin : '');

// Create an axios instance with default config
// baseURL includes /api so all requests go to /api/*
// withCredentials ensures httpOnly auth cookies are sent automatically
const apiClient = axios.create({
  baseURL: `${API_URL}/api`,
  timeout: 30000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a response interceptor to handle common errors
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // Normalize FastAPI 422 validation errors so `detail` is always a string.
    // Without this, components that render `error.response.data.detail` directly
    // crash with React Error #31 (objects are not valid as a React child).
    if (error.response?.status === 422) {
      const detail = error.response.data?.detail;
      if (Array.isArray(detail)) {
        error.response.data.detail = detail
          .map((e: any) => (typeof e === 'object' && e.msg ? e.msg : String(e)))
          .join('. ');
      } else if (typeof detail !== 'string' && detail != null) {
        error.response.data.detail = String(detail);
      }
    }

    // Handle 401 Unauthorized errors (token expired)
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      // Don't hard-redirect for the initial auth check — AuthContext
      // handles that gracefully and public pages must stay accessible.
      const url = originalRequest?.url || '';
      if (!url.endsWith('/users/me')) {
        window.location.href = '/login';
      }
    }

    return Promise.reject(error);
  }
);

export default apiClient; 